import { useState } from 'react';
import { useRefinementList } from 'react-instantsearch';

import InstantSearchAccordion from './units/instantSearchAccordion';
import InstantSearchFilterOption from './units/instantSearchFilterOption';

import type { FilterBaseProps } from '@javascript/types/InstantSearch';

const FeaturesFilter = ({ filtersOpen }: FilterBaseProps) => {
  const [input, setInput] = useState('');

  const { items, refine } = useRefinementList({
    attribute: 'bucketedFeatures',
    limit: 100,
    operator: 'and',
  });

  const handleChange = ({
    target: { value },
  }: React.ChangeEvent<HTMLInputElement>) => {
    setInput(value);
  };

  const selectedOptions = items
    .filter((item) => item.isRefined)
    .map((item) => item.label)
    .join(', ');

  const options =
    input.length > 1
      ? items.filter((item) =>
          item.label.toLowerCase().includes(input.toLowerCase())
        )
      : items;

  return (
    <InstantSearchAccordion
      filtersOpen={filtersOpen}
      label="Features"
      selectedOptions={selectedOptions}
    >
      <div className="ch-mv--2">
        <div className="ch-form__group ch-mb--4">
          <label className="ch-fs--3 ch-mb--0" htmlFor="features-search">
            Search features
          </label>
          <p className="ch-fs--3 ch-color--grey-6 ch-fw--400 ch-mb--0">
            e.g. Apple CarPlay or Heated Seats
          </p>
          <input
            className="ch-form__control ac-features-search__input ch-pl--8"
            id="features-search"
            onChange={handleChange}
            type="text"
            value={input}
          />
        </div>
        {options.length === 0 ? (
          <div className="ch-pv--2 ch-ph--3 ch-mb--1 ch-bg--grey-1 ch-rounded--sm">
            <p className="ch-mb--0 ch-fs--2 ch-color--grey-6">
              No results found for &quot;{input}&quot;
            </p>
          </div>
        ) : (
          <ul>
            {options.map(({ count, isRefined, label, value }) => (
              <InstantSearchFilterOption.CheckBox
                count={count}
                id={`features-${label}`}
                isSelected={isRefined}
                key={`features-${label}`}
                label={label}
                onChange={() => refine(value)}
              />
            ))}
          </ul>
        )}
      </div>
    </InstantSearchAccordion>
  );
};

export default FeaturesFilter;
